import React, { useEffect, useRef, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { all_routes } from "../../router/all_routes";
import { Studentlist } from "../../../core/data/json/studentList";
import { TableData } from "../../../core/data/interface";
import ImageWithBasePath from "../../../core/common/imageWithBasePath";
import Table from "../../../core/common/dataTable/index";
import PredefinedDateRanges from "../../../core/common/datePicker";
import {
  allClass,
  allSection,
  gender,
  names,
  status,
} from "../../../core/common/selectoption/selectoption";
import CommonSelect from "../../../core/common/commonSelect";
import TooltipOption from "../../../core/common/tooltipOption";
import UserService from "../../network/services/UserService";
import StudentModals from "../../peoples/students/studentModals";
import { getUser } from "../../network/auth/Auth";

const SchoolList = () => {
  const routes = all_routes;

  const dropdownMenuRef = useRef<HTMLDivElement | null>(null);

  const location = useLocation()
  const navigation = useNavigate()


  interface CompanyDataOption {
    id: any;
    name: any;
    email: any;
    phone: any;
    city: any;
    logo: any;
    branches: any;
    company_ids: any;


  }

  interface Option2 {
    id: any;
    name: any;
    email: any;
    phone: any;
    city: any;
    logo: any;
    branches: any;
    company_ids: any;

  }
  const [companies, setCompanies] = useState<CompanyDataOption[]>([]);
  const [company, setCompany] = useState<Option2>();

  const getCompanyDetailsBypartnerId = async (id: any) => {
    await UserService.getCompanyDetailsBypartnerId(id, (response: any) => {
      if (response?.data && response?.success) {
        setCompanies(response.data[0].company_ids[0].branches)

      }
    })
  }

  const navigeAcademyYearDetails = (academyYear: any) => {
    navigation(routes.studentDetail, { state: { academyYear: academyYear } })
  }

  const handleApplyClick = () => {
    if (dropdownMenuRef.current) {
      dropdownMenuRef.current.classList.remove("show");
    }
  };


  const [timelines, setTimelines] = useState<any>([]);
  const getAllTimelines = () => {
    console.log("users")
    console.log('goooooo--------------------------')

    UserService.getTimelines((response: any) => {

      if (response?.success === true) {
        setTimelines(response.data)
      }
    })
  }

  useEffect(() => {
    getAllTimelines()
  }, [])


  const recordDescriptions: { [key: number]: any } = {
    1: 'Tricycle',
    2: 'Dyna',
    3: 'Dyna',
    4: 'Fourgon',
    5: 'Fourgon',
    6: 'Remorques',
  };

  const columns = [
    {
      title: "ID",
      dataIndex: "id",
      render: (text: string) => (
        <Link to={routes.teacherDetails} className="link-primary">
          {text}
        </Link>
      ),
      sorter: (a: any, b: any) => a.id.length - b.id.length,
    },

    {
      title: "Pickup place name",
      dataIndex: "pickup_place_name",
      render: (record: any) => (
        <div className="d-flex flex-wrap gap-2">

          <span className="badge rounded-pill bg-success text-white mr-2">
            {record}
          </span>

        </div>
      ),
      sorter: (a: any, b: any) => a.pickup_place_name.length - b.pickup_place_name.length,
    },
    {
      title: "Dropoff place name",
      dataIndex: "dropoff_place_name",
      render: (record: any) => (
        <div className="d-flex flex-wrap gap-2">

          <span className="badge rounded-pill bg-warning text-white mr-2">
            {record}
          </span>

        </div>
      ),
      sorter: (a: any, b: any) => a.dropoff_place_name.length - b.dropoff_place_name.length,
    },
    {
      title: "Status",
      dataIndex: "status",
      render: (record: any) => (
        <div className="d-flex flex-wrap gap-2">

          <span className="badge rounded-pill bg-light text-dark mr-2">
            {record}
          </span>

        </div>
      ),
      sorter: (a: any, b: any) =>
        a.status.length - b.status.length,
    },
    {
      title: "price",
      dataIndex: "prix",
      render: (record: any) => (
        <>

          <span className="">

            {record}
          </span>

        </>
      ),
      sorter: (a: any, b: any) =>
        a.prix.length - b.prix.length,
    },
    {
      title: "urgence",
      dataIndex: "urgence",
      render: (record: any) => (
        <span className="">

          {record}
        </span>
      ),
      sorter: (a: any, b: any) =>
        a.urgence.length - b.urgence.length,
    },

    {
      title: "Vehicle",
      dataIndex: "vehicle_id",
      render: (record: any) => (
        <span className="">

          {recordDescriptions[record] || null}
        </span>
      ),
      sorter: (a: any, b: any) =>
        a.urgence.length - b.urgence.length,
    },

    {
      title: "Action",
      dataIndex: "action",
      render: () => (
        <>
          <div className="d-flex align-items-center">
            <div className="dropdown">
              <Link
                to="#"
                className="btn btn-white btn-icon btn-sm d-flex align-items-center justify-content-center rounded-circle p-0"
                data-bs-toggle="dropdown"
                aria-expanded="false"
              >
                <i className="ti ti-dots-vertical fs-14" />
              </Link>
              <ul className="dropdown-menu dropdown-menu-right p-3">
                <li>
                  <Link
                    className="dropdown-item rounded-1"
                    to={routes.teacherDetails}
                  >
                    <i className="ti ti-menu me-2" />
                    View Teacher
                  </Link>
                </li>
                <li>
                  <Link
                    className="dropdown-item rounded-1"
                    to={routes.editTeacher}
                  >
                    <i className="ti ti-edit-circle me-2" />
                    Edit
                  </Link>
                </li>
                <li>
                  <Link
                    className="dropdown-item rounded-1"
                    to="#"
                    data-bs-toggle="modal"
                    data-bs-target="#login_detail"
                  >
                    <i className="ti ti-lock me-2" />
                    Login Details
                  </Link>
                </li>
                <li>
                  <Link className="dropdown-item rounded-1" to="#">
                    <i className="ti ti-toggle-right me-2" />
                    Disable
                  </Link>
                </li>
                <li>
                  <Link
                    className="dropdown-item rounded-1"
                    to="#"
                    data-bs-toggle="modal"
                    data-bs-target="#delete-modal"
                  >
                    <i className="ti ti-trash-x me-2" />
                    Delete
                  </Link>
                </li>
              </ul>
            </div>
          </div>
        </>
      ),
    },
  ];
  return (
    <>
      {/* Page Wrapper */}
      <div className="page-wrapper">
        <div className="content">
          {/* Page Header */}
          <div className="d-md-flex d-block align-items-center justify-content-between mb-3">
            <div className="my-auto mb-2">
              <h3 className="page-title mb-1">Timelines List</h3>
              <nav>
                <ol className="breadcrumb mb-0">
                  <li className="breadcrumb-item">
                    <Link to={routes.adminDashboard}>Dashboard</Link>
                  </li>
                  <li className="breadcrumb-item">Timelines</li>
                  <li className="breadcrumb-item active" aria-current="page">
                    Timelines List
                  </li>
                </ol>
              </nav>
            </div>
            <div className="d-flex my-xl-auto right-content align-items-center flex-wrap">
              <TooltipOption />


            </div>
          </div>
          {/* /Page Header */}
          {/* Students List */}
          <div className="card">
            <div className="card-header d-flex align-items-center justify-content-between flex-wrap pb-0">
              <h4 className="mb-3">Timelines List</h4>
              <div className="d-flex align-items-center flex-wrap">
                <div className="input-icon-start mb-3 me-2 position-relative">
                  <PredefinedDateRanges />
                </div>
                <div className="dropdown mb-3 me-2">
                  <Link
                    to="#"
                    className="btn btn-outline-light bg-white dropdown-toggle"
                    data-bs-toggle="dropdown"
                    data-bs-auto-close="outside"
                  >
                    <i className="ti ti-filter me-2" />
                    Filter
                  </Link>
                  <div
                    className="dropdown-menu drop-width"
                    ref={dropdownMenuRef}
                  >
                    <form>
                      <div className="d-flex align-items-center border-bottom p-3">
                        <h4>Filter</h4>
                      </div>
                      <div className="p-3 pb-0 border-bottom">
                        <div className="row">
                          <div className="col-md-6">
                            <div className="mb-3">
                              <label className="form-label">Class</label>
                              <CommonSelect
                                className="select"
                                options={allClass}
                                defaultValue={allClass[0]}
                              />
                            </div>
                          </div>
                          <div className="col-md-6">
                            <div className="mb-3">
                              <label className="form-label">Section</label>
                              <CommonSelect
                                className="select"
                                options={allSection}
                                defaultValue={allSection[0]}
                              />
                            </div>
                          </div>
                          <div className="col-md-12">
                            <div className="mb-3">
                              <label className="form-label">Name</label>
                              <CommonSelect
                                className="select"
                                options={names}
                                defaultValue={names[0]}
                              />
                            </div>
                          </div>
                          <div className="col-md-6">
                            <div className="mb-3">
                              <label className="form-label">Gender</label>
                              <CommonSelect
                                className="select"
                                options={gender}
                                defaultValue={gender[0]}
                              />
                            </div>
                          </div>
                          <div className="col-md-6">
                            <div className="mb-3">
                              <label className="form-label">Status</label>
                              <CommonSelect
                                className="select"
                                options={status}
                                defaultValue={status[0]}
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="p-3 d-flex align-items-center justify-content-end">
                        <Link to="#" className="btn btn-light me-3">
                          Reset
                        </Link>
                        <Link
                          to={routes.studentGrid}
                          className="btn btn-primary"
                          onClick={handleApplyClick}
                        >
                          Apply
                        </Link>
                      </div>
                    </form>
                  </div>
                </div>
                <div className="d-flex align-items-center bg-white border rounded-2 p-1 mb-3 me-2">
                  <Link
                    to={routes.schoolList}
                    className="active btn btn-icon btn-sm me-1 primary-hover"
                  >
                    <i className="ti ti-list-tree" />
                  </Link>
                  <Link
                    to={routes.schoolGrid}
                    className="btn btn-icon btn-sm bg-light primary-hover"
                  >
                    <i className="ti ti-grid-dots" />
                  </Link>
                </div>
                <div className="dropdown mb-3">
                  <Link
                    to="#"
                    className="btn btn-outline-light bg-white dropdown-toggle"
                    data-bs-toggle="dropdown"
                  >
                    <i className="ti ti-sort-ascending-2 me-2" />
                    Sort by A-Z
                  </Link>
                  <ul className="dropdown-menu p-3">
                    <li>
                      <Link to="#" className="dropdown-item rounded-1 active">
                        Ascending
                      </Link>
                    </li>
                    <li>
                      <Link to="#" className="dropdown-item rounded-1">
                        Descending
                      </Link>
                    </li>
                    <li>
                      <Link to="#" className="dropdown-item rounded-1">
                        Recently Viewed
                      </Link>
                    </li>
                    <li>
                      <Link to="#" className="dropdown-item rounded-1">
                        Recently Added
                      </Link>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            <div className="card-body p-0 py-3">
              {/* Student List */}

              <Table dataSource={timelines} columns={columns} Selection={true} />

              {/* /Student List */}
            </div>
          </div>
          {/* /Students List */}
        </div>
      </div>
      {/* /Page Wrapper */}
      <StudentModals />
    </>
  );
};

export default SchoolList;
